import { colTheme } from './colTheme';
import { novaTheme } from './novaTheme';
import { tecnoTheme } from './tecnoTheme';
import { matteTheme } from './matteTheme';
import { posTheme } from './posTheme';
import { vaisandTheme } from './vaisandTheme';

const themeOptions = {
    matteTheme: matteTheme,
    tecnoTheme: tecnoTheme,
    posTheme: posTheme,
    colTheme: colTheme,
    vaisandTheme: vaisandTheme,
    default: novaTheme,
};

export function themeFactory(theme) {
    return themeOptions[theme] || themeOptions['default'];
}
